import { Injectable } from '@angular/core';
import { AdvancedCommerceService } from '@df/module-advanced-commerce';

@Injectable({
    providedIn: 'root'
})
export class LocalAdvancedCommerceService extends AdvancedCommerceService {
    override get additionalPostData(): Object {
        return {
            args: {
                website_code:
                    this.app.resources?.attribute
                        ?.getExisting('websites_proper')
                        ?.data?.options?.find(o => o.label === this.app.data.websiteCode)
                        ?.value?.toString() || '9165'
            }
        };
    }
}
